// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"339":"953dcdea","453":"52cac4ce","948":"3eadb489"}[chunkId] + ".chunk.js";
};